module.exports = __webpack_public_path__ + "public/media/img_service_example.d513b229.png";